import { render, staticRenderFns } from "./rate-max-editor.vue?vue&type=template&id=fed22938&scoped=true"
import script from "./rate-max-editor.vue?vue&type=script&lang=js"
export * from "./rate-max-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed22938",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fed22938')) {
      api.createRecord('fed22938', component.options)
    } else {
      api.reload('fed22938', component.options)
    }
    module.hot.accept("./rate-max-editor.vue?vue&type=template&id=fed22938&scoped=true", function () {
      api.rerender('fed22938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-rate/rate-max-editor.vue"
export default component.exports